/**
 * Cross-layer boot state. main.ts fills it from the server before or while
 * the scene boots; the scene consumes it exactly once. A mutable module
 * object instead of a bus event because the scene may not exist yet when
 * the sync response arrives (and vice versa).
 */
import type { WorldToUiEvents } from './bus.js';

export const sessionState: {
  /** Position saved by a previous session — crash/tab-close recovery. */
  restorePosition: { x: number; y: number } | null;
  /** Latest city info from sync — the scene may boot after the first sync
   *  lands, so the bus event alone would be missed (US 03.x). */
  cityInfo: WorldToUiEvents['city-info'] | null;
} = {
  restorePosition: null,
  cityInfo: null,
};
